import { Form, Icons, Input, Space } from '@pankod/refine-antd'
import React, { useState } from 'react'
import { useUserContext } from 'context/user'

interface Props {
  searchValue?: string
  handleSearch: (searchValue: string) => void
  setCurrentPageValue: (pageNumber: number) => void
  additionalFilters: any
  limit: number
  userRole: string
  userId: string
  fetchQuestions: (limit: number, currentPage: number, searchValue: string, userRole: string, userId: string, additionalFilters: any) => Promise<void>
}

const QuestionSearch: React.FC<Props> = ({ handleSearch, setCurrentPageValue, additionalFilters, limit, userRole, userId, fetchQuestions }) => {
  const { userLastSearch, updateUserLastSearch } = useUserContext()
  const [search, setSearch] = useState<string>('')
  const handleSearchAction = async () => {
    localStorage.setItem(`allquestions_${userId}_${userRole}_page_number`, '1')
    setCurrentPageValue(1)
    //keeping last searched question value in the state
    updateUserLastSearch('question', search || '')
    await fetchQuestions(limit, 1, search, userRole, userId, additionalFilters)
  }
  return (
    <div>
      <Form>
        <Space>
          <Form.Item name="name">
            <Input
              placeholder="Search by name or question id(s), eg. 115619,115618"
              style={{ width: 320 }}
              allowClear
              onChange={e => {
                handleSearch(e?.target?.value)
                setSearch(e?.target?.value)
              }}
              defaultValue={userLastSearch?.question || ''}
              onPressEnter={handleSearchAction}
              suffix={<Icons.SearchOutlined style={{ cursor: 'pointer' }} onClick={handleSearchAction} />}
            />
          </Form.Item>
        </Space>
      </Form>
    </div>
  )
}

export default QuestionSearch
